import React from 'react';
import styled from 'styled-components';

const ViewProfileDiv = styled.div``;

export default function ViewProfile() {
	return <ViewProfileDiv>View Profile</ViewProfileDiv>;
}
